import { ThemedText } from "@/components/themed-text";
import { BrandColors } from "@/constants/theme";
import { useNetworkStatus } from "@/hooks/use-network-status";
import Ionicons from "@react-native-vector-icons/ionicons";
import React from "react";
import { StyleSheet, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export function OfflineBanner() {
  const { isConnected } = useNetworkStatus();
  const insets = useSafeAreaInsets();

  if (isConnected !== false) {
    return null;
  }

  return (
    <View
      style={[styles.container, { paddingTop: insets.top }]}
      accessibilityRole="alert"
    >
      <Ionicons
        name="cloud-offline-outline"
        size={16}
        color={BrandColors.white}
      />
      <ThemedText style={styles.text} type="extraSmallSemiBold">
        You are offline. Some features may be unavailable.
      </ThemedText>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: BrandColors.error,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    paddingBottom: 8,
    paddingHorizontal: 16,
    width: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
  },
  text: {
    color: BrandColors.white,
  },
});
